exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".pui-hint[data-v-d3203d7e]{outline:unset}.pui-hint[data-v-d3203d7e]:focus{color:var(--focus-color) !important}.pui-hint[data-v-d3203d7e]:hover{color:var(--hover-color) !important}\n", ""]);

